module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M24 6H2C.894 6 0 6.894 0 8v22c0 1.106.894 2 2 2h22c1.106 0 2-.894 2-2V8c0-1.106-.894-2-2-2zm-4.538 14.168l-9.026 5.496c-.92.762-2.436.184-2.436-1.3V13.636c0-1.48 1.516-2.064 2.438-1.3l8.644 5.496c.968.646 1.348 1.692.38 2.336zM30 0H8C6.894 0 6 .894 6 2v2h20c1.106 0 2 .894 2 2v20h2c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/media-gallery-1.js
// module id = 1266
// module chunks = 14